(function () {
  'use strict';

  function isThemeToggleInstance(element) {
    if (!window.customElements || typeof window.customElements.get !== 'function') {
      return false;
    }

    var customElementName = element.getAttribute('is');
    var constructor = customElementName ? window.customElements.get(customElementName) : null;

    if (!constructor) {
      return false;
    }

    try {
      return element instanceof constructor;
    } catch (error) {
      return false;
    }
  }

  function setControlledElementState(toggle, expanded) {
    var controlledId = toggle.getAttribute('aria-controls');
    var controlledElement = controlledId ? document.getElementById(controlledId) : null;

    if (!controlledElement) {
      return false;
    }

    toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    controlledElement.toggleAttribute('open', expanded);
    controlledElement.classList.toggle('is-open', expanded);

    if (expanded) {
      controlledElement.removeAttribute('hidden');
    }

    return true;
  }

  function closeControlledElement(controlledElement) {
    if (!controlledElement) {
      return;
    }

    controlledElement.removeAttribute('open');
    controlledElement.classList.remove('is-open');

    document.querySelectorAll('[aria-controls]').forEach(function (control) {
      if (control.getAttribute('aria-controls') === controlledElement.id) {
        control.setAttribute('aria-expanded', 'false');
      }
    });
  }

  function getDropdown(item) {
    return item ? item.querySelector('.modern-mega-menu, .standard-dropdown') : null;
  }

  function setDropdownState(item, expanded) {
    var dropdown = getDropdown(item);
    var link = item ? item.querySelector(':scope > a[aria-controls]') : null;

    if (!dropdown) {
      return false;
    }

    dropdown.hidden = !expanded;
    dropdown.style.display = expanded ? 'block' : 'none';
    dropdown.classList.toggle('is-open', expanded);

    if (link) {
      link.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    }

    return true;
  }

  var activeMenuItem = null;
  var menuHideTimeout = null;

  function showMenuItem(item) {
    window.clearTimeout(menuHideTimeout);

    if (activeMenuItem && activeMenuItem !== item) {
      setDropdownState(activeMenuItem, false);
    }

    if (setDropdownState(item, true)) {
      activeMenuItem = item;
    }
  }

  function scheduleMenuItemClose(item) {
    window.clearTimeout(menuHideTimeout);
    menuHideTimeout = window.setTimeout(function () {
      setDropdownState(item, false);
      if (activeMenuItem === item) {
        activeMenuItem = null;
      }
    }, 400);
  }

  document.addEventListener('mouseover', function (event) {
    var item = event.target.closest('.header__linklist-item.has-dropdown');
    if (!item || (event.relatedTarget && item.contains(event.relatedTarget))) {
      return;
    }

    showMenuItem(item);
  });

  document.addEventListener('mouseout', function (event) {
    var item = event.target.closest('.header__linklist-item.has-dropdown');
    if (!item || (event.relatedTarget && item.contains(event.relatedTarget))) {
      return;
    }

    scheduleMenuItemClose(item);
  });

  document.addEventListener('focusin', function (event) {
    var item = event.target.closest('.header__linklist-item.has-dropdown');
    if (item) {
      showMenuItem(item);
    }
  });

  document.addEventListener('focusout', function (event) {
    var item = event.target.closest('.header__linklist-item.has-dropdown');
    if (item && (!event.relatedTarget || !item.contains(event.relatedTarget))) {
      scheduleMenuItemClose(item);
    }
  });

  document.addEventListener('click', function (event) {
    var toggle = event.target.closest('[is="toggle-link"][aria-controls], [is="toggle-button"][aria-controls]');

    if (toggle) {
      var themeHandledClick = event.defaultPrevented || isThemeToggleInstance(toggle);
      var expanded = themeHandledClick
        ? toggle.getAttribute('aria-expanded') === 'true'
        : toggle.getAttribute('aria-expanded') !== 'true';

      if (setControlledElementState(toggle, expanded) && !themeHandledClick) {
        event.preventDefault();
      }
      return;
    }

    var dropdownLink = event.target.closest('.header__linklist-item.has-dropdown > a[aria-controls]');
    if (dropdownLink && window.matchMedia('(hover: none)').matches) {
      var dropdownItem = dropdownLink.closest('.header__linklist-item.has-dropdown');
      var shouldOpen = dropdownLink.getAttribute('aria-expanded') !== 'true';

      if (setDropdownState(dropdownItem, shouldOpen)) {
        event.preventDefault();
        activeMenuItem = shouldOpen ? dropdownItem : null;
      }
      return;
    }

    var closeControl = event.target.closest('[data-action="close"], .drawer__overlay');
    if (!closeControl) {
      return;
    }

    var controlledElement = closeControl.closest('[open], .is-open');
    if (!controlledElement) {
      return;
    }

    closeControlledElement(controlledElement);
  });
})();
